import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormErrorService {
  public getInvalidControlsKeys(formGroup: FormGroup | null | undefined): string[] {
    const invalidControls: string[] = [];
    if (!formGroup) {
      return invalidControls;
    }
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control && control.invalid) {
        invalidControls.push(key);
      }
    });
    return invalidControls;
  }
}
